export const IOS_APP_STORE = "https://apps.apple.com/cn/app/id1054598922";

export const ANDROID_MARKET_FALLBACK =
  "https://a.app.qq.com/o/simple.jsp?pkgname=com.mcdonalds.gma.cn";

export const PAGE_TITLE = "奶昔大哥看球中";

/** 分享 H5 主视觉切图 */
export const SHARE_H5_BG_IMG = "https://img.mcd.cn/gallery/79fbab2b62a0231c.png";

/** 打开看看 / 底部 CTA 按钮切图 */
export const SHARE_H5_BTN_IMG = "https://img.mcd.cn/gallery/90fb6a07f916fcaa.png";

/** 推荐餐品模块背景（与弹幕区底对齐，右侧留白由样式控制） */
export const RECOMMEND_MEAL_CARD_BG = "https://img.mcd.cn/gallery/6bdf7ecb12d05f4a.png";

export const SHARE_GUIDE_TEXT =
  "我在和奶昔大哥一起看球，竞猜世界杯还有机会赢多种豪礼，你也来试试吧～";

export const OPEN_BTN_IMG_URL = 'https://img.mcd.cn/gallery/da275f1746485147.png'

export const BOTTOM_CTA_TEXT = "去麦当劳App 看奶昔大哥直播";

/** 呼起 App RN 直播间（FifaMatchLive），三端页名与原生约定一致 */
const LIVE_DEEPLINK =
  "mcdapp://page?iosPageName=MCDReactNativeViewController&androidPageName=com.mcd.library.rn.McdReactNativeActivity&harmonyPageName=RNPage&parameters=" +
  encodeURIComponent(
    JSON.stringify({
      rctModule: "campaign",
      rctModuleName: "FifaMatchLive",
      rctModuleParams: { showBg: "true" },
    })
  );

export const APP_OPEN = {
  liveExtInfo: LIVE_DEEPLINK,
};

export type DanmakuItem = {
  nickname: string;
  content: string;
  avatar?: string;
};

export const DANMAKU_AVATARS = [
  "https://img.mcd.cn/gallery/eb11e654d451c20e.png",
  "https://img.mcd.cn/gallery/199a6d809c6a7bc5.png",
  "https://img.mcd.cn/gallery/874a484f62812ea3.png",
  "https://img.mcd.cn/gallery/1bee234362e6d44d.png",
];

/** 「来了」弹幕池 */
export const MOCK_DANMAKU_ARRIVAL_POOL: DanmakuItem[] = [
  { nickname: "P**h", content: "来了" },
  { nickname: "N**k", content: "来了" },
  { nickname: "G**o", content: "来了" },
  { nickname: "E*a", content: "来了" },
  { nickname: "e**y", content: "来了" },
  { nickname: "晓**！", content: "来了" },
  { nickname: "小*干", content: "来了" },
  { nickname: "嘻*", content: "来了" },
  { nickname: "我**吉", content: "来了" },
  { nickname: "微**户", content: "来了" },
  { nickname: "四**理", content: "来了" },
  { nickname: "萌*", content: "来了" },
  { nickname: "猫**y", content: "来了" },
  { nickname: "胡**卜", content: "来了" },
  { nickname: "朵**泡", content: "来了" },
  { nickname: "T**a", content: "来了" },
];

/** 预测弹幕池 */
export const MOCK_DANMAKU_PREDICTION_POOL: DanmakuItem[] = [
  { nickname: "P**h", content: "预测了墨西哥胜利!" },
  { nickname: "N**k", content: "预测了南非胜利!" },
  { nickname: "G**o", content: "预测了韩国胜利!" },
  { nickname: "E*a", content: "预测了捷克胜利!" },
  { nickname: "e**y", content: "预测了加拿大胜利!" },
  { nickname: "晓**！", content: "预测了波黑胜利!" },
  { nickname: "小*干", content: "预测了美国胜利!" },
  { nickname: "嘻*", content: "预测了巴拉圭胜利!" },
  { nickname: "我**吉", content: "预测了墨西哥胜利!" },
  { nickname: "微**户", content: "预测了南非胜利!" },
  { nickname: "四**理", content: "预测了韩国胜利!" },
  { nickname: "萌*", content: "预测了捷克胜利!" },
  { nickname: "猫**y", content: "预测了加拿大胜利!" },
  { nickname: "胡**卜", content: "预测了波黑胜利!" },
  { nickname: "朵**泡", content: "预测了美国胜利!" },
  { nickname: "T**a", content: "预测了巴拉圭胜利!" },
];

export const DANMAKU_VISIBLE_COUNT = 4;

/** 直播间分享页视觉稿基准宽度 */
export const LIVE_SHARE_DESIGN_WIDTH = 393;
